import { render } from "./Dropzone.vue?vue&type=template&id=68db3414"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"
script.render = render

export default script